module.exports = __webpack_public_path__ + "static/media/bex.57192831.jpg";